module.exports = __webpack_public_path__ + "static/media/pollution-4846741_640.264efc9c.jpg";